export interface AssetClass {
  id: string;
  name: string;
}

export interface AssetAllocation {
  assetClassId: string;
  percentage: number;
  amount: number;
}

export enum AccountType {
  TAX_DEFERRED = 'taxDeferred',
  TAX_FREE = 'taxFree', 
  TAXABLE_INVESTMENT = 'taxableInvestment',
  CASH_SAVINGS = 'cashSavings'
}

export interface AccountBalance {
  accountType: AccountType;
  balance: number;
  allocations: AssetAllocation[];
}

export interface Portfolio {
  allocations: AssetAllocation[];
  totalValue: number;
}

export interface SimulationParameters {
  accountBalances: AccountBalance[];
  socialSecurityMonthlyBenefit: number;
  monthlySpendingTarget: number;
  simulationPeriods: number; // Number of years
  numberOfSimulations: number;
}

export interface SimulationResult {
  period: number;
  percentiles: {
    // p5: number;
    p10: number;
    // p25: number;
    p50: number;
    // p75: number;
    // p90: number;
    // p95: number;
  };
}

export interface ChartDataPoint {
  period: number;
  // p5: number;
  p10: number;
  // p25: number;
  p50: number;
  // p75: number;
  // p90: number;
  // p95: number;
}

export interface AccountBreakdownDataPoint {
  period: number;
  taxDeferred: number;
  taxFree: number;
  taxableInvestment: number;
  cashSavings: number;
  total: number;
}

export interface SimulationResults {
  numberOfSimulations: number;
  simulationPeriods: number;
  accountBreakdown: AccountBreakdownDataPoint[];
  totalPortfolioData: ChartDataPoint[];
  withdrawalData: WithdrawalDataPoint[];
  allSimulationRuns: AccountBreakdownDataPoint[][];
}

export interface WithdrawalDataPoint {
  year: number;
  // p5: number;
  p10: number;
  // p25: number;
  p50: number;
  // p75: number;
  // p90: number;
  // p95: number;
}
